import { render, staticRenderFns } from "./loginByCodeTbLogin.vue?vue&type=template&id=473b1165&scoped=true"
import script from "./loginByCodeTbLogin.vue?vue&type=script&lang=js"
export * from "./loginByCodeTbLogin.vue?vue&type=script&lang=js"
import style0 from "./loginByCodeTbLogin.vue?vue&type=style&index=0&id=473b1165&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "473b1165",
  null
  
)

export default component.exports